//LSEC_PC_01
import React, { Component } from 'react';
import * as CookieService from '../CookieService';
import * as $ from 'jquery';
import SDIConstants from '../SDIConstants';
import Select from 'react-select';
import { withTranslation, Trans } from 'react-i18next'
import * as LoadStageErrorAction from '../actions/LoadStageErrorAction';
import LoadStageErrorStore from '../stores/LoadStageErrorStore';
import * as MenuAction from '../actions/MenuAction';
import { color } from '@material-ui/system';
import { eachDayOfInterval } from 'date-fns/esm';
import swal from 'sweetalert';
//LSEC_PC_02
let currentPagePath;
class LoadStageErrorComponent extends Component {
    constructor(props) {
        super(props);
        this.SaveButtonClickResponse = this.SaveButtonClickResponse.bind(this);
        //LSEC_PC_03
        this.PageLoadResponse = this.PageLoadResponse.bind(this);
        this.OnStageChangeResponse = this.OnStageChangeResponse.bind(this);
        this.state = {
            StagingID: [],
            ParentDetail: [],
            ChildDetail: [],
            NestedChildDetail: [],
            storageLocation: [],
            Area: [],
            Aisle: [],
            Row: [],
            Shelf: [],
            Bin: [],
            NonOwned: false,
            MakeDefault: true,
            Putaway: false,
            SelectedArea: {},
            SelectedAisel: {},
            SelectedRow: {},
            SelectedShelf: {},
            SelectedBin: {},
            SelectedStageID: "",
            EditDetail: [], isFavorited: false, Error: "", LocationError: false, ErrorDisplay: "", CribID: "", PO_ID_Data: [], PO_ID_Value: "", ItemId: [], selectedItemId: ""
        }
    }
    //LSEC_PC_04
    componentDidMount() {
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        CookieService.updateLocalStorageValues("Session_PageName", window.location.pathname);
        currentPagePath = this.props.location.pathname;
        currentPagePath = currentPagePath.indexOf("?") >= 0 ? currentPagePath.split("?")[0] : currentPagePath;
        let getFavPageBO = {
            Session_USERID: CookieService.getLocalStorageValues("Session_UserID"),
            pageURL: currentPagePath.toLowerCase(),
            Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT")
        };
        LoadStageErrorAction.getCurrentFavPage(getFavPageBO);
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        if (CookieService.getLocalStorageValues("Session_ISA_CRIB_IDENT") == null || CookieService.getLocalStorageValues("Session_ISA_CRIB_IDENT") == undefined ||
            CookieService.getLocalStorageValues("Session_ISA_CRIB_IDENT") == "" || CookieService.getLocalStorageValues("Session_ISA_CRIB_IDENT") == " ") {
            let cribID = CookieService.getLocalStorageValues("Session_ISA_CRIB_IDENT");
            if (CookieService.getLocalStorageValues("HideMobility") && CookieService.getLocalStorageValues("HideMobility").toUpperCase() == "TRUE") {
                swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    text: "No crib has been selected. Please contact the admin/manager to assign a crib"
                });
                this.props.history.push({
                    pathname: `/homepage`
                });
            }
            else {
                swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    text: "Please select crib from user profile"
                });
                this.props.history.push({
                    pathname: `/profile`,
                    state: { origin: 'Inventory' }
                });
            }
            return;
        }
        let BO = {
            //  CribID: "W10"
            Session_UserId: CookieService.getLocalStorageValues("Session_UserID")
        }
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        LoadStageErrorAction.pageload(BO);
        LoadStageErrorStore.on('StagingID', this.PageLoadResponse);
        LoadStageErrorStore.on('Details', this.OnStageChangeResponse);
        LoadStageErrorStore.on('LoadStageErrorSave', this.SaveButtonClickResponse);
        LoadStageErrorStore.on('favpage', this.loadFavPageResponse);
        LoadStageErrorStore.on('updateFavPage', this.updateFavPageResponse);
    }
    componentWillUnmount() {
        LoadStageErrorStore.removeListener('LoadStageErrorSave', this.SaveButtonClickResponse);
        LoadStageErrorStore.removeListener('StagingID', this.PageLoadResponse);
    }
    loadFavPageResponse = () => {
        let favPageResponse = JSON.parse(LoadStageErrorStore.currentFavPageResponse);
        if (favPageResponse.length > 0) {
            favPageResponse = favPageResponse[0];
            this.setState({ isFavorited: true, Page_ID: favPageResponse.PAGE_ID });
        };
    };
    updateFavPageResponse = () => {
        if (LoadStageErrorStore.updateFavPageResponse.updateType == 1) {

            let response = JSON.parse(LoadStageErrorStore.updateFavPageResponse.responseStr)[0];
            if (response.is_Success == "True") {
                $(`#${SDIConstants.SDILoader}`).addClass('hide');
                this.setState({ isFavorited: true, Page_ID: response.Page_ID });
                MenuAction.toastMessage(1);
            }

        } else {
            let response = JSON.parse(LoadStageErrorStore.updateFavPageResponse.responseStr)[0];
            if (response.success == "true") {
                $(`#${SDIConstants.SDILoader}`).addClass('hide');
                this.setState({ isFavorited: false });
                MenuAction.toastMessage(2);
            }
        }
        // isPostBack = false;
        //this.refreshMenu();
        MenuAction.refreshMasterData()
    };
    //STKICC_PC_
    handleFavorite = (event) => {
        this.setState({ isFavorited: event.target.checked });
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        if (event.target.checked == true) {
            let insertFavPageBO = {
                Session_USERID: CookieService.getLocalStorageValues("Session_UserID"),
                pageURL: currentPagePath.toLowerCase(),
                pageTitle: "Load Stage and Putaway",
                Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT")
            }
            LoadStageErrorAction.insertFavPage(insertFavPageBO)
        } else {
            let deleteFavPageBO = {
                Page_ID: this.state.Page_ID
            }
            LoadStageErrorAction.deleteFavPage(deleteFavPageBO)
        }
    };
    //LSEC_PC_05
    PageLoadResponse = () => {
        
        let PageLoadResponse = JSON.parse(LoadStageErrorStore.PageLoadData);
        let flag = "";
        if (PageLoadResponse.Flag != null && PageLoadResponse.Flag != undefined) {
            if (PageLoadResponse.Flag.length > 0) {
                flag = PageLoadResponse.Flag[0].CribID
            }
        }
        if (flag != "" && flag != null && flag != undefined) {
            if (PageLoadResponse.Table != null && PageLoadResponse.Table != undefined) {
                if (PageLoadResponse.Table.length > 0) {
                    this.setState({ StagingID: PageLoadResponse.Table });
                }//WW-363_PC_01 (8/8/2022)-Aparna
                else {
                    this.setState({ Error: "There is no Staging ID for this Crib id" });
                }
            }
            if (PageLoadResponse.POIDData != null && PageLoadResponse.POIDData != undefined) {
                if (PageLoadResponse.POIDData.length > 0) {
                    this.setState({ PO_ID_Data: PageLoadResponse.POIDData });
                }
                else {
                    this.setState({ PO_ID_Data: [] });
                }
            }
            if (PageLoadResponse.ItemID != null && PageLoadResponse.ItemID != undefined) {
                if (PageLoadResponse.ItemID.length > 0) {
                    this.setState({ ItemId: PageLoadResponse.ItemID });
                }
                else {
                    this.setState({ ItemId: [] });
                }
            }
        }
        else {
            this.setState({ Error: "Don't have crib id .Please select it in user profile" });
        }
        this.setState({ CribID: flag });
    }
    //LSEC_PC_07
    OnStageChangeResponse = () => {
        let PageLoadResponse = JSON.parse(LoadStageErrorStore.PageLoadData);
        let locParentDetail = [];
        let locChildDetail = [];
        let locNestedChildDetail = [];
        let locStorageLocation = [];



        if (PageLoadResponse.ParentDetail != null && PageLoadResponse.ParentDetail != undefined) {
            if (PageLoadResponse.ParentDetail.length > 0) {
                locParentDetail = PageLoadResponse.ParentDetail
            }
        }
        if (PageLoadResponse.ChildDetail != null && PageLoadResponse.ChildDetail != undefined) {
            if (PageLoadResponse.ChildDetail.length > 0) {
                locChildDetail = PageLoadResponse.ChildDetail
            }
        }
        if (PageLoadResponse.NestedChildDetail != null && PageLoadResponse.NestedChildDetail != undefined) {
            if (PageLoadResponse.NestedChildDetail.length > 0) {
                locNestedChildDetail = PageLoadResponse.NestedChildDetail
            }
        }
        if (PageLoadResponse.StorageLocation != null && PageLoadResponse.StorageLocation != undefined) {
            if (PageLoadResponse.StorageLocation.length > 0) {
                locStorageLocation = PageLoadResponse.StorageLocation
            }
        }
        //WW-363_PC_03
        if (locParentDetail.length > 0) {
            this.setState({ ParentDetail: locParentDetail, ChildDetail: locChildDetail, NestedChildDetail: locNestedChildDetail, StorageLocation: locStorageLocation })
        } else {
            let BO = {
                Session_UserId: CookieService.getLocalStorageValues("Session_UserID")
            }
            $(`#${SDIConstants.SDILoader}`).removeClass('hide');
            LoadStageErrorAction.pageload(BO);
            this.setState({ ParentDetail: locParentDetail, ChildDetail: locChildDetail, NestedChildDetail: locNestedChildDetail, StorageLocation: locStorageLocation })
        }



    }
    BindPO_ID = () => {
        if (this.state.PO_ID_Data.length > 0) {
            return this.state.PO_ID_Data.map((value, ID) => {
                return (
                    <option key={value.PO_ID} value={value.PO_ID}>{value.PO_ID}</option>
                )

            });
        }

    }
    bindItemID = () => {
        if (this.state.ItemId.length > 0) {
            return this.state.ItemId.map((value, ID) => {
                return (
                    <option key={value.ITEM_ID} value={value.ITEM_ID}>{value.ITEM_ID}</option>
                )

            });
        }

    }
    BindStagingID = () => {
        return this.state.StagingID.map((value, ID) => {
            return (
                <option key={value.STAGINGID} value={value.STAGINGID}>{value.STAGINGID}</option>
            )

        });
    }
    BindAreaDD = () => {
        return this.state.Area.map((value, ID) => {
            return (
                <option key={value.value} value={value.value}>{value.value}</option>
            )

        });
    }
    BindAisle = () => {
        return this.state.Aisle.map((value, ID) => {
            return (
                <option key={value.value} value={value.value}>{value.value}</option>
            )

        });
    }
    BindRow = () => {
        return this.state.Row.map((value, ID) => {
            return (
                <option key={value.value} value={value.value}>{value.value}</option>
            )

        });
    }
    BindShelf = () => {
        return this.state.Shelf.map((value, ID) => {
            return (
                <option key={value.value} value={value.STAGINGID}>{value.value}</option>
            )

        });
    }
    BindBin = () => {
        return this.state.Bin.map((value, ID) => {
            return (
                <option key={value.value} value={value.value}>{value.value}</option>
            )

        });
    }
    //LSEC_PC_12
    SaveButtonClickResponse = () => {
        let Resposnse = JSON.parse(LoadStageErrorStore.PageLoadData);
        if (Resposnse.Flag != null && Resposnse.Flag != undefined) {
            if (Resposnse.Flag[0].Update == "True") {
                $('#Edit-Storage-Area').modal('hide');
                $('.header-arrow').removeClass('accordion-arrow-change');
                $('.content-row').addClass('d-none');
                swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    text: "Updated Successfully"
                });
                //  alert("Updated Successfully");
                this.setState({ EditDetail: [] });
                let BO = {
                    CribID: this.state.CribID,
                    StagingID: parseInt(this.state.SelectedStageID),
                    BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT"),
                    Session_UserId: CookieService.getLocalStorageValues("Session_UserID"),
                    PO_ID: this.state.PO_ID_Value,
                    Page_Load_Item_Id: this.state.selectedItemId
                }
                $(`#${SDIConstants.SDILoader}`).removeClass('hide');
                LoadStageErrorAction.OnStageChangeAction(BO);
                this.setState({ LocationError: false });
            }
        }
    }
    //LSEC_PC_06
    OnStageChange = (event, Type) => {
        
        let PO_ID = "";
        let Stage_ID = 0;
        let itemId = "";
        $('.header-arrow').removeClass('accordion-arrow-change');
        $('.content-row').addClass('d-none');
        if (Type == "PO") {
            PO_ID = event.target.value;
            this.setState({ PO_ID_Value: event.target.value, SelectedStageID: "", selectedItemId: "" })
            //console.error("DeepPOID", this.state.PO_ID_Value);
        }
        else if (Type == "Stage") {
            Stage_ID = event.target.value;
            this.setState({ SelectedStageID: event.target.value, PO_ID_Value: "", selectedItemId: "" })
        }
        else if (Type == "ItemID") {
            itemId = event.target.value;
            this.setState({ selectedItemId: event.target.value, PO_ID_Value: "", SelectedStageID: "" })
        }
        if ((Type == "PO" && event.target.value == "") || (Type == "Stage" && event.target.value == "") || (Type == "ItemID" && event.target.value == "")) {
            this.setState({ ParentDetail: [], ChildDetail: [], NestedChildDetail: [], StorageLocation: [] })
        }
        else {
            let BO = {
                CribID: this.state.CribID,
                StagingID: parseInt(Stage_ID),
                BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT"),
                Session_UserId: CookieService.getLocalStorageValues("Session_UserID"),
                PO_ID: PO_ID,
                Page_Load_Item_Id: itemId
            }
            $(`#${SDIConstants.SDILoader}`).removeClass('hide');
            LoadStageErrorAction.OnStageChangeAction(BO);
        }

    }
    onAccordianClick = (event, index) => {
        $(event.currentTarget).children().toggleClass('accordion-arrow-change');
        $(`#contentrow-${index}`).toggleClass('d-none');
        $('tr').removeClass('tr-border');
        $(event.currentTarget).parent('tr').addClass('tr-border');
    };
    //LSEC_PC_
    OnChangeStorage = (name, event) => {
        switch (name) {
            case "Putaway": {
                let { EditDetail } = this.state
                EditDetail.PUTAWAY_FLAG = EditDetail.PUTAWAY_FLAG == 'N' ? 'Y' : 'N';
                this.setState({ EditDetail });
                break;
            }
            case "MakeDefault": {
                let { EditDetail } = this.state
                EditDetail.MakeDefault = !EditDetail.MakeDefault
                this.setState({ EditDetail });
                //this.setState({ MakeDefault: !this.state.MakeDefault });
                break;
            }
            case "Owned": {
                let { EditDetail } = this.state
                EditDetail.NON_OWN_FLAG = EditDetail.NON_OWN_FLAG == 'N' ? 'Y' : 'N';
                this.setState({ EditDetail });
                break;
            }
            case "Area": {
                let Aisledd = [];
                let pp = [];
                if (event.target.value != "NULL") {


                    this.state.StorageLocation.map((item, index) => {
                        if (item.STORAGE_AREA == event.target.value && Aisledd.indexOf(item.STOR_LEVEL_1) == -1) {
                            let obj = {
                                value: item.STOR_LEVEL_1,
                                label: item.STOR_LEVEL_1
                            }
                            Aisledd.push(obj);
                        }
                    })
                    pp = Aisledd.filter((ele, ind) => ind === Aisledd.findIndex(elem => elem.value === ele.value && elem.label === ele.label))
                }
                let { EditDetail } = this.state
                EditDetail.STORAGE_AREA = event.target.value;
                EditDetail.STOR_LEVEL_1 = "NULL"
                EditDetail.STOR_LEVEL_2 = "NULL"
                EditDetail.STOR_LEVEL_3 = "NULL"
                EditDetail.STOR_LEVEL_4 = "NULL"
                this.setState({ EditDetail });

                this.setState({ Aisle: pp, Row: [], Shelf: [], Bin: [] });

                break;
            }
            case "Aisle": {
                let Rowdd = [];
                let pp = [];
                if (event.target.value != "NULL") {
                    this.state.StorageLocation.map((item, index) => {
                        if (item.STORAGE_AREA == this.state.EditDetail.STORAGE_AREA && item.STOR_LEVEL_1 == event.target.value
                            && Rowdd.indexOf(item.STOR_LEVEL_2) == -1
                        ) {
                            let obj = {
                                value: item.STOR_LEVEL_2,
                                label: item.STOR_LEVEL_2
                            }
                            Rowdd.push(obj);
                        }
                    })
                    pp = Rowdd.filter((ele, ind) => ind === Rowdd.findIndex(elem => elem.value === ele.value && elem.label === ele.label))
                }
                let { EditDetail } = this.state
                EditDetail.STOR_LEVEL_1 = event.target.value;
                EditDetail.STOR_LEVEL_2 = "NULL"
                EditDetail.STOR_LEVEL_3 = "NULL"
                EditDetail.STOR_LEVEL_4 = "NULL"
                this.setState({ EditDetail });
                this.setState({ Row: pp, Shelf: [], Bin: [] })
                break;
            }
            case "Row": {
                let Shelfdd = [];
                let pp = [];
                if (event.target.value != "NULL") {
                    this.state.StorageLocation.map((item, index) => {
                        if (item.STORAGE_AREA == this.state.EditDetail.STORAGE_AREA && item.STOR_LEVEL_1 == this.state.EditDetail.STOR_LEVEL_1
                            && item.STOR_LEVEL_2 == event.target.value && Shelfdd.indexOf(item.STOR_LEVEL_3) == -1
                        ) {
                            let obj = {
                                value: item.STOR_LEVEL_3,
                                label: item.STOR_LEVEL_3
                            }
                            Shelfdd.push(obj);
                        }
                    })
                    pp = Shelfdd.filter((ele, ind) => ind === Shelfdd.findIndex(elem => elem.value === ele.value && elem.label === ele.label))
                }
                let { EditDetail } = this.state
                EditDetail.STOR_LEVEL_2 = event.target.value;
                EditDetail.STOR_LEVEL_3 = "NULL"
                EditDetail.STOR_LEVEL_4 = "NULL"
                this.setState({ EditDetail });
                this.setState({ Shelf: pp, Bin: [] })
                break;
            }
            case "Shelf": {
                let Bindd = [];
                let pp = [];
                if (event.target.value != "NULL") {
                    this.state.StorageLocation.map((item, index) => {
                        if (item.STORAGE_AREA == this.state.EditDetail.STORAGE_AREA && item.STOR_LEVEL_1 == this.state.EditDetail.STOR_LEVEL_1
                            && item.STOR_LEVEL_3 == event.target.value && item.STOR_LEVEL_2 == this.state.EditDetail.STOR_LEVEL_2 && Bindd.indexOf(item.STOR_LEVEL_4) == -1
                        ) {
                            let obj = {
                                value: item.STOR_LEVEL_4,
                                label: item.STOR_LEVEL_4
                            }
                            Bindd.push(obj);
                        }
                    })
                    pp = Bindd.filter((ele, ind) => ind === Bindd.findIndex(elem => elem.value === ele.value && elem.label === ele.label));
                }
                let { EditDetail } = this.state
                EditDetail.STOR_LEVEL_3 = event.target.value;
                EditDetail.STOR_LEVEL_4 = "NULL";
                this.setState({ EditDetail });
                this.setState({ Bin: pp })
                break;
            }
            case "Bin": {
                let { EditDetail } = this.state
                EditDetail.STOR_LEVEL_4 = event.target.value;
                this.setState({ EditDetail });
                break;
            }
        }
    }

    //LSEC_PC_08
    EditButtonclick = (ItemID) => {
        let locEditDetailstore = this.state.ChildDetail.filter((x) => x.INV_ITEM_ID == ItemID.INV_ITEM_ID);
        let locEditDetail = {
            STORAGE_AREA: locEditDetailstore[0].STORAGE_AREA,
            STOR_LEVEL_1: locEditDetailstore[0].STOR_LEVEL_1,
            STOR_LEVEL_2: locEditDetailstore[0].STOR_LEVEL_2,
            STOR_LEVEL_3: locEditDetailstore[0].STOR_LEVEL_3,
            STOR_LEVEL_4: locEditDetailstore[0].STOR_LEVEL_4,
            NON_OWN_FLAG: locEditDetailstore[0].NON_OWN_FLAG,
            PUTAWAY_FLAG: locEditDetailstore[0].PUTAWAY_FLAG,
            INV_ITEM_ID: locEditDetailstore[0].INV_ITEM_ID,
            MakeDefault: false
        }


        let AreaDD = [];
        let locArea = []
        if (this.state.StorageLocation.length > 0) {
            this.state.StorageLocation.forEach((item, index) => {

                let obj = {
                    value: item.STORAGE_AREA,
                    label: item.STORAGE_AREA
                };
                AreaDD.push(obj);

            });
            locArea = AreaDD.filter((ele, ind) => ind === AreaDD.findIndex(elem => elem.value === ele.value && elem.label === ele.label))
            if (locEditDetail.STORAGE_AREA != "" && locEditDetail.STORAGE_AREA != null && locEditDetail.STORAGE_AREA != undefined) {

                let Aisledd = [];
                this.state.StorageLocation.forEach((item, index) => {
                    if (item.STORAGE_AREA == locEditDetail.STORAGE_AREA && Aisledd.indexOf(item.STOR_LEVEL_1) == -1) {
                        let obj = {
                            value: item.STOR_LEVEL_1,
                            label: item.STOR_LEVEL_1
                        }
                        Aisledd.push(obj);
                    }
                })
                let pp = Aisledd.filter((ele, ind) => ind === Aisledd.findIndex(elem => elem.value === ele.value && elem.label === ele.label))
                this.setState({ Aisle: pp })
                let Rowdd = [];
                this.state.StorageLocation.forEach((item, index) => {
                    if (item.STORAGE_AREA == locEditDetail.STORAGE_AREA && item.STOR_LEVEL_1 == locEditDetail.STOR_LEVEL_1
                        && Rowdd.indexOf(item.STOR_LEVEL_2) == -1
                    ) {
                        let obj = {
                            value: item.STOR_LEVEL_2,
                            label: item.STOR_LEVEL_2
                        }
                        Rowdd.push(obj);
                    }
                })
                let rr = Rowdd.filter((ele, ind) => ind === Rowdd.findIndex(elem => elem.value === ele.value && elem.label === ele.label))
                this.setState({ Row: rr })

                let Shelfdd = [];
                this.state.StorageLocation.forEach((item, index) => {
                    if (item.STORAGE_AREA == locEditDetail.STORAGE_AREA && item.STOR_LEVEL_1 == locEditDetail.STOR_LEVEL_1
                        && item.STOR_LEVEL_2 == locEditDetail.STOR_LEVEL_2 && Shelfdd.indexOf(item.STOR_LEVEL_3) == -1
                    ) {
                        let obj = {
                            value: item.STOR_LEVEL_3,
                            label: item.STOR_LEVEL_3
                        }
                        Shelfdd.push(obj);
                    }
                })
                let S = Shelfdd.filter((ele, ind) => ind === Shelfdd.findIndex(elem => elem.value === ele.value && elem.label === ele.label))
                this.setState({ Shelf: S })

                let Bindd = [];
                this.state.StorageLocation.forEach((item, index) => {
                    if (item.STORAGE_AREA == locEditDetail.STORAGE_AREA && item.STOR_LEVEL_1 == locEditDetail.STOR_LEVEL_1
                        && item.STOR_LEVEL_3 == locEditDetail.STOR_LEVEL_3 && item.STOR_LEVEL_2 == locEditDetail.STOR_LEVEL_2 && Bindd.indexOf(item.STOR_LEVEL_4) == -1
                    ) {
                        let obj = {
                            value: item.STOR_LEVEL_4,
                            label: item.STOR_LEVEL_4
                        }
                        Bindd.push(obj);
                    }
                })
                let B = Bindd.filter((ele, ind) => ind === Bindd.findIndex(elem => elem.value === ele.value && elem.label === ele.label))
                this.setState({ Bin: B });
            }
        }


        this.setState({ EditDetail: locEditDetail, Area: locArea });
        $('#Edit-Storage-Area').modal('show');
    }

    BindChildDetails = (ItemID) => {
        return this.state.ChildDetail.map((ChildVal, index) => {
            if (ChildVal.INV_ITEM_ID == ItemID) {


                return (
                    <tr className="p">
                        <td colSpan={12} className="hiddenRow">
                            <div className="accordian-body  py-1 mt-3 ml-4 pl-2" id="order-row-1">

                                <div className="row mx-0 pb-0">
                                    <div className="col-md-10 pl-4 mb-1">

                                        <div className="row">

                                            <div className="col-md-3 pr-0 mb-2">
                                                <label className="catalog-label mr-2" id={`Area#L-${index}`}><Trans>Area</Trans></label>
                                                <label className="item-details-value" id={`Area#-${index}`}>{ChildVal.STORAGE_AREA}</label>
                                            </div>

                                            <div className="col-md-3 pr-0 mb-2">
                                                <label className="catalog-label mr-2" id={`Aisle-${index}`}><Trans>Aisle :</Trans></label>
                                                <label className="item-details-value" id={`Aisle-${index}`}>{ChildVal.STOR_LEVEL_1}</label>

                                            </div>
                                            <div className="col-md-3 pr-0 mb-2">
                                                <label className="catalog-label mr-2" id={`Row-${index}`}>Row :</label>
                                                <label className="item-details-value" id={`Row-${index}`}>{ChildVal.STOR_LEVEL_2}</label>
                                            </div>
                                            <div className="col-md-3 pr-0 mb-2">
                                                <label className="catalog-label mr-2" id={`Shelf-${index}`}>Shelf:</label>
                                                <label className="item-details-value" id={`Shelf-${index}`}>{ChildVal.STOR_LEVEL_3}</label>
                                            </div>
                                            <div className="col-md-3 pr-0 mb-2">
                                                <label className="catalog-label mr-2" id={`Bin-${index}`}><Trans>Bin</Trans><span> :</span></label>
                                                <label className="item-details-value " id={`Bin-${index}`}>{ChildVal.STOR_LEVEL_4}</label>
                                            </div>

                                            <div className="col-md-3 pr-0 mb-2">
                                                <div className="custom-control custom-checkbox  mt-0 item-custom-control ml-0 float-left">
                                                    <input type="checkbox" className="custom-control-input" id={`PutAway-${index}`} name="" checked={ChildVal.PUTAWAY_FLAG == 'N' ? false : true} onChange={e => this.OnChangeStorage("PutAway", e)} />
                                                    <label className="custom-control-label custombtn-disabled" htmlFor={`PutAway-${index}`} >Putaway Flag</label>
                                                </div>

                                            </div>
                                            {/*<div className="col-md-3 pr-0 mb-2">
                                                <div className="custom-control custom-checkbox  mt-0 item-custom-control ml-0 float-left">
                                                    <input type="checkbox" className="custom-control-input" id={`MakeDefault-${index}`} name="" checked={true} onChange={e => this.OnChangeStorage("MakeDefault", e)} />
                                                    <label className="custom-control-label custombtn-disabled" htmlFor={`MakeDefault-${index}`} >Make Default?</label>
                                                </div>

                                            </div>*/}
                                            <div className="col-md-3 pr-0 mb-2">
                                                <div className="custom-control custom-checkbox  mt-0 item-custom-control ml-0 float-left">
                                                    <input type="checkbox" className="custom-control-input" id={`NonOwned-${index}`} name="" checked={ChildVal.NON_OWN_FLAG == 'N' ? false : true} onChange={e => this.OnChangeStorage("NonOwned", e)} />
                                                    <label className="custom-control-label custombtn-disabled" htmlFor={`NonOwned-${index}`} >Non Owned</label>
                                                </div>
                                                {/*<label className="custom-control-label custombtn-disabled" htmlFor={`NonOwned-${index}`} >Non Owned</label>*/}
                                            </div>



                                        </div>
                                        <div className="row ">
                                            <div className="col-md-12 pr-0 mb-2">
                                                <label className="catalog-label mr-2" >Edit Error</label>
                                            </div>
                                        </div>


                                        {this.BindNestedChildDetail(ItemID)}


                                    </div>


                                </div>
                            </div>

                        </td>
                    </tr>

                )
            }
        });

    }
    BindParentDetail = () => {
        return this.state.ParentDetail.map((value, index) => {
            console.log("ParentDetail", this.state.ParentDetail)
            return (
                <React.Fragment key={index}>

                    <tr>
                        <td className="text-center">
                        </td>
                        <td className="accordion-toggle" onClick={(e) => this.onAccordianClick(e, index)} >
                            <span className="accordion-arrow header-arrow" id={`arrow-${index}`} />
                        </td>
                        <td className="d-sm-none d-md-table-cell"><div style={{ width: '100px' }}>{value.BUSINESS_UNIT}</div></td>
                        <td className="d-none d-sm-none d-md-table-cell" ><div style={{ width: '80px' }} id={`WO#-${index}`}>{value.INV_ITEM_ID}</div></td>
                        <td className="d-none d-sm-none d-md-table-cell" ><div style={{ width: '80px' }} id={`PO#-${index}`}>{value.PO_ID}</div></td>
                        {/* Regression bug 5266 In Load stage error Description UI look not good need to change as extension - Yuvarani K */}
                        <td className="d-none d-sm-none d-md-table-cell"><div style={{ width: '250px' }} id={`billtostore-${index}`}>{value.DESCR254}</div></td>
                        <td className="d-none d-sm-none d-md-table-cell"><div style={{ width: '100px' }} id={`ENTEREDEMPNAME-${index}`}>{value.STAGED_DATE}</div></td>
                        <td className="d-none d-sm-none d-md-table-cell"><div style={{ width: '50px' }} id={`ORD_DATE-${index}`}>{value.QTY}</div></td>
                        <td className="d-none d-sm-none d-md-table-cell"><div style={{ width: '80px' }} id={`ORD_DATE-${index}`}>{value.UOM}</div></td>
                        <td className="d-none d-sm-none d-md-table-cell"><div style={{ width: '80px' }} id={`ORD_DATE-${index}`}>{value.DISTRIB_TYPE}</div></td>
                        <td className="d-none d-sm-none d-md-table-cell"><div style={{ width: '80px' }} id={`ORD_DATE-${index}`}>{value.CONTAINER_ID}</div></td>
                        <td className="d-none d-sm-none d-md-table-cell"><div style={{ width: '80px' }} id={`ORD_DATE-${index}`}>{value.Storage_Code}</div></td>
                        <td className="d-none d-sm-none d-md-table-cell"><div style={{ width: '80px' }} id={`ORD_DATE-${index}`}>{value.INV_STOCK_TYPE}</div></td>
                        <td className="d-none d-sm-none d-md-table-cell"><div id={`ORD_DATE-${index}`}> <a className="edit-icon float-left m-1 pointercursor" style={{ cursor: "Pointer" }} data-backdrop="static" data-keyboard="false" onClick={(e) => this.EditButtonclick(value)} /></div></td>


                    </tr>
                    <tr className="p d-none content-row" id={`contentrow-${index}`}>
                        <td colSpan="12" style={{ paddingBottom: '0' }}>
                            <div className="accordian-body py-0 px-1" id="order-row-1">
                                <div className="row justify-content-center">
                                    <div className="col-md-12" style={{ marginLeft: '0%' }}>
                                        <table className="table ZEUS_Grid FOM-grid chk-ordertbl" style={{ marginBottom: '0', borderSpacing: '0' }}>
                                            <tbody>
                                                {/*   <tr className="p d-none content-row" id={`contentrow-${index}`}> */}
                                                <h4 className="item-details-title mt-2 mb-0 ml-3 pl-5">Storage Area</h4>
                                                {this.BindChildDetails(value.INV_ITEM_ID)}

                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </td>
                    </tr>





                </React.Fragment>
            )
        });
    }

    //LSEC_PC_
    BindNestedChildDetail = (ItemID) => {
        return this.state.NestedChildDetail.map((NChildVal, index) => {
            if (NChildVal.INV_ITEM_ID == ItemID) {


                return (
                    <>

                        <div className="row ">

                            <div className="col-md-3 pr-0 mb-2">
                                <label className="catalog-label mr-2" id={`Field Name#L-${index}`}><Trans>Field Name</Trans> <span> :</span></label>
                                <label className="item-details-value" id={`Field Name#-${index}`}>{NChildVal.TSE_FIELDNAME}</label>
                            </div>

                            <div className="col-md-3 pr-0 mb-2">
                                <label className="catalog-label mr-2" id={`Msg Seq-${index}`}><Trans>Msg Seq</Trans><span> </span><span> :</span></label>
                                <label className="item-details-value" id={`Msg Seq-${index}`}>{NChildVal.MESSAGE_SET_NBR}</label>

                            </div>
                            <div className="col-md-3 pr-0 mb-2">
                                <label className="catalog-label mr-2" id={`Row-${index}`}>Msg :</label>
                                <label className="item-details-value" id={`Row-${index}`}>{NChildVal.MESSAGE_NBR}</label>
                            </div>
                            <div className="col-md-6 pr-0 mb-2">

                                <label className="item-details-value" id={`Row-${index}`}>{NChildVal.MESSAGE_TEXT}</label>
                            </div>
                        </div>
                    </>
                );
            }
        });
    }
    SaveButtonClick = () => {
        let validation = true
        let errormsg = ""
        if ((this.state.EditDetail.STORAGE_AREA == "" || this.state.EditDetail.STORAGE_AREA == null || this.state.EditDetail.STORAGE_AREA == " " || this.state.EditDetail.STORAGE_AREA == "NULL") && (this.state.EditDetail.STOR_LEVEL_1 == "" || this.state.EditDetail.STOR_LEVEL_1 == null || this.state.EditDetail.STOR_LEVEL_1 == " " || this.state.EditDetail.STOR_LEVEL_1 == "NULL")
            && (this.state.EditDetail.STOR_LEVEL_2 == " " || this.state.EditDetail.STOR_LEVEL_2 == "" || this.state.EditDetail.STOR_LEVEL_2 == null || this.state.EditDetail.STOR_LEVEL_2 == "NULL") && (this.state.EditDetail.STOR_LEVEL_3 == " " || this.state.EditDetail.STOR_LEVEL_3 == "" || this.state.EditDetail.STOR_LEVEL_3 == null || this.state.EditDetail.STOR_LEVEL_3 == "NULL")
            && (this.state.EditDetail.STOR_LEVEL_4 == " " || this.state.EditDetail.STOR_LEVEL_4 == "" || this.state.EditDetail.STOR_LEVEL_4 == null || this.state.EditDetail.STOR_LEVEL_4 == "NULL")) {
            errormsg = "Please select Area, Aisle, Row, Shelf and Bin"
        }
        else if (this.state.EditDetail.STORAGE_AREA == "" || this.state.EditDetail.STORAGE_AREA == null || this.state.EditDetail.STORAGE_AREA == " " || this.state.EditDetail.STORAGE_AREA == "NULL") {
            errormsg = "Please select Area"
        }
        else if (this.state.EditDetail.STOR_LEVEL_1 == "" || this.state.EditDetail.STOR_LEVEL_1 == null || this.state.EditDetail.STOR_LEVEL_1 == " " || this.state.EditDetail.STOR_LEVEL_1 == "NULL") {
            errormsg = "Please select Aisle"
        }
        else if (this.state.EditDetail.STOR_LEVEL_2 == "" || this.state.EditDetail.STOR_LEVEL_2 == null || this.state.EditDetail.STOR_LEVEL_2 == " " || this.state.EditDetail.STOR_LEVEL_2 == "NULL") {
            errormsg = "Please select Row"
        }
        else if (this.state.EditDetail.STOR_LEVEL_3 == "" || this.state.EditDetail.STOR_LEVEL_3 == null || this.state.EditDetail.STOR_LEVEL_3 == " " || this.state.EditDetail.STOR_LEVEL_3 == "NULL") {
            errormsg = "Please select Shelf"
        }
        else if (this.state.EditDetail.STOR_LEVEL_4 == "" || this.state.EditDetail.STOR_LEVEL_4 == null || this.state.EditDetail.STOR_LEVEL_4 == " " || this.state.EditDetail.STOR_LEVEL_4 == "NULL") {
            errormsg = "Please select Bin"
        }
        if (errormsg != "") {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: errormsg
            });
            return;
        }
        this.setState({ ErrorDisplay: errormsg });
        if (this.state.EditDetail.STORAGE_AREA == "NULL" || this.state.EditDetail.STOR_LEVEL_1 == "NULL" || this.state.EditDetail.STOR_LEVEL_2 == "NULL"
            || this.state.EditDetail.STOR_LEVEL_3 == "NULL" || this.state.EditDetail.STOR_LEVEL_4 == "NULL") {
            validation = false
            this.setState({ LocationError: true });
            if (this.state.EditDetail.STORAGE_AREA == null || this.state.EditDetail.STOR_LEVEL_1 == null || this.state.EditDetail.STOR_LEVEL_2 == null
                || this.state.EditDetail.STOR_LEVEL_3 == null || this.state.EditDetail.STOR_LEVEL_4 == null) {
                validation = false
                this.setState({ LocationError: true });
            }
        }
        //WW_363_PC_02 (8/9/2022)-Aparna
        //if (validation == false) {
        //    if ((this.state.EditDetail.STORAGE_AREA == "" || this.state.EditDetail.STORAGE_AREA == null || this.state.EditDetail.STORAGE_AREA == " ") && (this.state.EditDetail.STOR_LEVEL_1 == "" || this.state.EditDetail.STOR_LEVEL_1 == null || this.state.EditDetail.STOR_LEVEL_1 == " " )
        //        && (this.state.EditDetail.STOR_LEVEL_2 == " " || this.state.EditDetail.STOR_LEVEL_2 == "" || this.state.EditDetail.STOR_LEVEL_2 == null) && (this.state.EditDetail.STOR_LEVEL_3==" " ||this.state.EditDetail.STOR_LEVEL_3 == "" || this.state.EditDetail.STOR_LEVEL_3 == null)
        //        && (this.state.EditDetail.STOR_LEVEL_4==" " ||this.state.EditDetail.STOR_LEVEL_4 == "" || this.state.EditDetail.STOR_LEVEL_4 == null)) {
        //        errormsg = "Please select Area, Aisle, Row, Shelf and Bin"
        //    }
        //    else if (this.state.EditDetail.STORAGE_AREA == "" || this.state.EditDetail.STORAGE_AREA == null) {
        //        errormsg ="Please select Area"
        //    }
        //    else if (this.state.EditDetail.STOR_LEVEL_1 == "" || this.state.EditDetail.STOR_LEVEL_1 ==null) {
        //        errormsg = "Please select Aisle"
        //    }
        //    else if (this.state.EditDetail.STOR_LEVEL_2 == "" || this.state.EditDetail.STOR_LEVEL_2 ==null) {
        //        errormsg = "Please select Row"
        //    }
        //    else if (this.state.EditDetail.STOR_LEVEL_3 == "" || this.state.EditDetail.STOR_LEVEL_3 ==null) {
        //        errormsg = "Please select Shelf"
        //    }
        //    else if (this.state.EditDetail.STOR_LEVEL_4 == "" || this.state.EditDetail.STOR_LEVEL_4 ==null) {
        //        errormsg = "Please select Bin"
        //    }
        //    this.setState({ ErrorDisplay: errormsg });
        //    return;
        //}
        if (validation) {

            let parentdetail = this.state.ParentDetail.filter((ele, ind) => ele.INV_ITEM_ID == this.state.EditDetail.INV_ITEM_ID)
            console.log("parentdetail".parentdetail)
            let BO = {
                //WW-1206 Load Stage Error -Yuvarani K
                CribID: parentdetail[0].BUSINESS_UNIT,
           
                StagingID: parseInt(this.state.SelectedStageID),
                ItemID: this.state.EditDetail.INV_ITEM_ID,
                BUSUNIT: "I0W01",
                Area: this.state.EditDetail.STORAGE_AREA,
                STOR_LEVEL_1: this.state.EditDetail.STOR_LEVEL_1,
                STOR_LEVEL_2: this.state.EditDetail.STOR_LEVEL_2,
                STOR_LEVEL_3: this.state.EditDetail.STOR_LEVEL_3,
                STOR_LEVEL_4: this.state.EditDetail.STOR_LEVEL_4,
                NON_OWN_FLAG: this.state.EditDetail.NON_OWN_FLAG,
                PUTAWAY_STATUS: this.state.EditDetail.PUTAWAY_FLAG,
                QTY: this.state.EditDetail.QTY,
                UNIT_OF_MEASURE: this.state.EditDetail.UOM,
                DISTRIB_TYPE: parentdetail[0].DISTRIB_TYPE,
                CONTAINER_ID: parentdetail[0].CONTAINER_ID,
                STORAGE_CODE: parentdetail[0].STORAGE_CODE,
                INV_STOCK_TYPE: parentdetail[0].INV_STOCK_TYPE,
                MakeDefault: this.state.EditDetail.MakeDefault,
                Session_UserId: CookieService.getLocalStorageValues("Session_UserID"),
                PO_ID: this.state.PO_ID_Value
            }
            $(`#${SDIConstants.SDILoader}`).removeClass('hide');
            LoadStageErrorAction.SaveButtonClickAction(BO)

        }
    }
    //LSEC_PC_
    CancelButtonClick = () => {
        this.setState({ EditDetail: [], LocationError: false });
        $('#Edit-Storage-Area').modal('hide');
    }
    //LSEC_PC_12
    render() {
        const { t } = this.props;
        return (
            <div>
                <div className="container-fluid content-section">
                    <div className="row">
                        {/* Shopping Cart starts */}
                        <div className="container-fluid content-margin">
                            <div className="row">
                                <div className="col-md-12 page-heading mb-3 ">
                                    <h5 className="page-title"><Trans>Load Stage and Putaway</Trans></h5>
                                    <div className="fav-item-maintenance-icon mt-1">
                                        <input type="checkbox" id="checkbox-a" className="checknow" name="isFavorited" checked={this.state.isFavorited} onChange={this.handleFavorite} />
                                        <label htmlFor="checkbox-a">
                                            <svg className="heart-svg" viewBox="467 392 58 57" xmlns="http://www.w3.org/2000/svg">
                                                <g className="Group" fill="none" fillRule="evenodd" transform="translate(467 392)">
                                                    <path d="M29.144 20.773c-.063-.13-4.227-8.67-11.44-2.59C7.63 28.795 28.94 43.256 29.143 43.394c.204-.138 21.513-14.6 11.44-25.213-7.214-6.08-11.377 2.46-11.44 2.59z" className="heart" fill="#fff" />
                                                    <circle className="main-circ" fill="#E2264D" opacity={0} cx="29.5" cy="29.5" r="1.5" />
                                                    <g className="grp7" opacity={0} transform="translate(7 6)">
                                                        <circle className="oval1" fill="#9CD8C3" cx={2} cy={6} r={2} />
                                                        <circle className="oval2" fill="#8CE8C3" cx={5} cy={2} r={2} />
                                                    </g>
                                                    <g className="grp6" opacity={0} transform="translate(0 28)">
                                                        <circle className="oval1" fill="#CC8EF5" cx={2} cy={7} r={2} />
                                                        <circle className="oval2" fill="#91D2FA" cx={3} cy={2} r={2} />
                                                    </g>
                                                    <g className="grp3" opacity={0} transform="translate(52 28)">
                                                        <circle className="oval2" fill="#9CD8C3" cx={2} cy={7} r={2} />
                                                        <circle className="oval1" fill="#8CE8C3" cx={4} cy={2} r={2} />
                                                    </g>
                                                    <g className="grp2" opacity={0} transform="translate(44 6)">
                                                        <circle className="oval2" fill="#CC8EF5" cx={5} cy={6} r={2} />
                                                        <circle className="oval1" fill="#CC8EF5" cx={2} cy={2} r={2} />
                                                    </g>
                                                    <g className="grp5" opacity={0} transform="translate(14 50)">
                                                        <circle className="oval1" fill="#91D2FA" cx={6} cy={5} r={2} />
                                                        <circle className="oval2" fill="#91D2FA" cx={2} cy={2} r={2} />
                                                    </g>
                                                    <g className="grp4" opacity={0} transform="translate(35 50)">
                                                        <circle className="oval1" fill="#F48EA7" cx={6} cy={5} r={2} />
                                                        <circle className="oval2" fill="#F48EA7" cx={2} cy={2} r={2} />
                                                    </g>
                                                    <g className="grp1" opacity={0} transform="translate(24)">
                                                        <circle className="oval1" fill="#9FC7FA" cx="2.5" cy={3} r={2} />
                                                        <circle className="oval2" fill="#9FC7FA" cx="7.5" cy={2} r={2} />
                                                    </g>
                                                </g>
                                            </svg>
                                        </label>
                                    </div>
                                </div>
                                <div className="col-lg-12 mb-4">

                                    <div className="p col-md-12 p-0 float-left">
                                        {/*<td colSpan={13} >*/}
                                        <div className="accordian-body" id="order-row1" style={{}}>
                                            <div className="col-md-12 ">
                                                <div className="row align-items-center">


                                                    <div className="col-md-3 col-lg-2 mb-3">
                                                        <label className="col-lg-6 col-md-12 float-left p-0 catalog-label form-label" id="StagingID"><Trans>Staging ID</Trans></label>
                                                        <select className="form-control" name="SelectedStageID" value={this.state.SelectedStageID} onChange={(e) => this.OnStageChange(e, "Stage")}>
                                                            <option value="">Select</option>
                                                            {this.BindStagingID()}
                                                        </select>
                                                    </div>
                                                    <div className="col-md-1 text-center mb-3">(OR)</div>
                                                    <div className="col-md-3 col-lg-2 mb-3">
                                                        <label className="col-lg-6 col-md-12 float-left p-0 catalog-label form-label"><Trans>PO ID</Trans></label>
                                                        <select className="form-control" name="SelectedPOID" value={this.state.PO_ID_Value} onChange={(e) => this.OnStageChange(e, "PO")}>
                                                            <option value="">Select</option>
                                                            {this.BindPO_ID()}
                                                        </select>
                                                    </div>
                                                    <div className="col-md-1 text-center mb-3">(OR)</div>
                                                    <div className="col-md-3 col-lg-2 mb-3">
                                                        <label className="col-lg-6 col-md-12 float-left p-0 catalog-label form-label"><Trans>Item ID</Trans></label>
                                                        <select className="form-control" name="SelectedItemID" value={this.state.selectedItemId} onChange={(e) => this.OnStageChange(e, "ItemID")}>
                                                            <option value="">Select</option>
                                                            {this.bindItemID()}
                                                        </select>
                                                    </div>
                                                    <div className="col-md-12 text-center">
                                                        <span style={{ fontSize: "15px", color: "Red" }}>{this.state.Error}</span>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                        {/*</td>*/}
                                    </div>
                                </div>
                                {this.state.ParentDetail.length > 0 ?
                                    <div className="row col-12">
                                        <div className="col-lg-12">
                                            <div className="table-responsive">
                                                <table className="table ZEUS_Grid FOM-grid chk-ordertbl">
                                                    <thead>
                                                        <tr>
                                                            <th />
                                                            <th />
                                                            <th className="d-sm-none d-md-table-cell position-sort-icon"><Trans>Business Unit</Trans></th>
                                                            <th className="d-none d-sm-none d-md-table-cell position-sort-icon"><Trans>Item ID</Trans></th>
                                                            <th className="d-none d-sm-none d-md-table-cell position-sort-icon"><Trans>PO ID</Trans></th>
                                                            <th className="d-none d-sm-none d-md-table-cell position-sort-icon"><Trans>Description</Trans></th>
                                                            <th className="d-none d-sm-none d-md-table-cell position-sort-icon"><Trans>Staged Date</Trans></th>
                                                            <th className="d-none d-sm-none d-md-table-cell position-sort-icon"><Trans>Qty</Trans></th>
                                                            <th className="d-none d-sm-none d-md-table-cell position-sort-icon"><Trans>UOM</Trans></th>
                                                            <th className="d-none d-sm-none d-md-table-cell position-sort-icon">Dist Type</th>
                                                            <th className="d-none d-sm-none d-md-table-cell position-sort-icon">Cntr ID</th>
                                                            <th className="d-none d-sm-none d-md-table-cell position-sort-icon">Store Code</th>
                                                            <th className="d-none d-sm-none d-md-table-cell position-sort-icon">Stock Type</th>
                                                            <th className="d-none d-sm-none d-md-table-cell position-sort-icon">Edit</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {this.state.ParentDetail.length > 0 ? this.BindParentDetail() :
                                                            (

                                                                <tr>
                                                                    <td colSpan={11}>
                                                                        <section className="site-undercontruction container text-center center-panel pt-4">
                                                                            <div className="img-section">
                                                                                <img src="images/nosearch.jpg" alt="imagefile" />
                                                                            </div>
                                                                            <p className="search-result-content pt-4"><Trans>Sorry, we couldn’t find any search result</Trans>
                                                                            </p>
                                                                        </section>
                                                                    </td>
                                                                </tr>)}
                                                        {/*{this.bindDataGrid()}*/}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div> : null}


                            </div>

                        </div>
                    </div>












                </div>
                <div className="modal" id="Edit-Storage-Area">
                    <div className="modal-dialog modal-lg custom-popup modal-dialog-centered">
                        <div className="modal-content">
                            {/* Modal Header */}
                            <div className="modal-header">
                                <h4 className="modal-title mt-1"><Trans>Edit Storage Area</Trans></h4>
                                <button type="button" className="btn close-btn" onClick={(e) => this.CancelButtonClick()}>
                                    X
              </button>
                            </div>
                            {/* Modal body */}
                            {this.state.EditDetail != null && this.state.EditDetail != undefined ?
                                <div className="modal-body" key={this.state.EditDetail.INV_ITEM_ID}>
                                    <div className="row mt-3">
                                        <div className="col-12 edit-desc-field mb-4">
                                            <div className="row mb-3 ">
                                                <label className="col-md-3 quick-label "><Trans>Item ID :</Trans></label>
                                                <div className="col-md-7 quick-value">
                                                    {this.state.EditDetail.INV_ITEM_ID}
                                                </div>
                                            </div>
                                            <div className="row mb-3">
                                                <label className="col-md-3 quick-label indicate-imp"><Trans>Area</Trans></label>
                                                <select className="form-control col-6 " name="SelectedStageID" value={this.state.EditDetail.STORAGE_AREA} onChange={(e) => this.OnChangeStorage("Area", e)}>
                                                    <option value="NULL">Select</option>
                                                    {this.BindAreaDD()}
                                                </select>
                                            </div>

                                            <div className="row mb-3 ">
                                                <label className="col-md-3 quick-label indicate-imp"><Trans>Aisle</Trans></label>
                                                <select className="form-control col-6" name="SelectedStageID" value={this.state.EditDetail.STOR_LEVEL_1} onChange={(e) => this.OnChangeStorage("Aisle", e)}>
                                                    <option value="NULL">Select</option>
                                                    {this.BindAisle()}
                                                </select>
                                            </div>
                                            <div className="row mb-3 ">
                                                <label className="col-md-3 quick-label indicate-imp"><Trans>Row</Trans></label>
                                                <select className="form-control col-6" name="SelectedStageID" value={this.state.EditDetail.STOR_LEVEL_2} onChange={(e) => this.OnChangeStorage("Row", e)}>
                                                    <option value="NULL">Select</option>
                                                    {this.BindRow()}
                                                </select>
                                            </div>
                                            <div className="row mb-3">
                                                <label className="col-md-3 quick-label indicate-imp">Shelf</label>
                                                <select className="form-control col-6 " name="SelectedStageID" value={this.state.EditDetail.STOR_LEVEL_3} onChange={(e) => this.OnChangeStorage("Shelf", e)}>
                                                    <option value="NULL">Select</option>
                                                    {this.BindShelf()}
                                                </select>
                                            </div>
                                            <div className="row mb-3 ">
                                                <label className="col-md-3 quick-label indicate-imp">Bin</label>
                                                <select className="form-control col-6" name="SelectedStageID" value={this.state.EditDetail.STOR_LEVEL_4} onChange={(e) => this.OnChangeStorage("Bin", e)}>
                                                    <option value="NULL">Select</option>
                                                    {this.BindBin()}
                                                </select>
                                            </div>
                                            <div className="row">
                                                <div className="col-md-12 pr-0 mb-2">
                                                    <div className="custom-control custom-checkbox  mt-0 item-custom-control ml-0 float-left">
                                                        <input type="checkbox" className="custom-control-input" id={`MakeDefault`} name="" checked={this.state.EditDetail.MakeDefault} onChange={e => this.OnChangeStorage("MakeDefault", e)} />
                                                        <label className="custom-control-label " style={{ fontSize: "15px" }} htmlFor={`MakeDefault`} >Make Default?</label>
                                                    </div>

                                                </div>

                                                <div className="col-md-12 pr-0 mb-2">
                                                    <div className="custom-control custom-checkbox  mt-0 item-custom-control ml-0 float-left">
                                                        <input type="checkbox" className="custom-control-input" id={`owned`} name="" checked={this.state.EditDetail.NON_OWN_FLAG == 'N' ? false : true} onChange={e => this.OnChangeStorage("Owned", e)} />
                                                        <label className="custom-control-label " style={{ fontSize: "15px" }} htmlFor={`owned`} >Non Owned</label>
                                                    </div>

                                                </div>
                                                <div className="col-md-12 pr-0 mb-2">
                                                    <div className="custom-control custom-checkbox  mt-0 item-custom-control ml-0 float-left">
                                                        <input type="checkbox" className="custom-control-input" id={`Putaway`} name="" checked={this.state.EditDetail.PUTAWAY_FLAG == 'N' ? false : true} onChange={e => this.OnChangeStorage("Putaway", e)} />
                                                        <label className="custom-control-label " style={{ fontSize: "15px" }} htmlFor={`Putaway`} >Putaway flag</label>
                                                    </div>

                                                </div>
                                            </div>
                                            {this.state.LocationError ?
                                                <div className=" row float-left">
                                                    <div className="col-md-12 mb-2">
                                                        <span className=" W-100 errorspan1" style={{ fontSize: '15px' }}>{this.state.ErrorDisplay}</span>
                                                    </div>
                                                </div> : null}
                                            <div className=" row col-12 ">
                                                <div className="col-md-12 p-0 mb-2">
                                                    <button className="btn btn-primary custom-btn-primary primary-btn px-4 " onClick={(e) => this.SaveButtonClick()} >Save</button>
                                                    <button className="btn custom-btn-primary secondary-btn px-4 " style={{ "marginLeft": "100px" }} onClick={(e) => this.CancelButtonClick()}>Cancel</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                : null}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
export default withTranslation()(LoadStageErrorComponent);